/** Invoice due amount for insert — LX/TMS projects use total_amount, not amount_due. */
export function invoiceDueAmount(amount) {
    return { total_amount: amount };
}

/** Outstanding balance from an invoice row (reads total_amount or legacy amount_due). */
export function invoiceOutstandingBalance(invoice) {
    const due = Number(invoice?.total_amount ?? invoice?.amount_due ?? 0);
    const paid = Number(invoice?.amount_paid ?? 0);
    return Math.max(0, due - paid);
}
